import { ApiProperty } from '@nestjs/swagger'
import { IsArray, IsUUID } from 'class-validator'
import { UserResponseDto } from './response.dto'

/**
 * DTO pour la requête batch de récupération d'utilisateurs
 */
export class GetUsersBatchRequestDto {
  @ApiProperty({
    description: 'IDs des utilisateurs à récupérer',
    type: [String],
    example: [
      'c341dd2d-f900-49b1-b0f0-cbb9b7833e51',
      'c341dd2d-f900-49b1-b0f0-cbb9b7833e52',
    ],
  })
  @IsArray()
  @IsUUID(undefined, { each: true })
  userIds!: string[]
}

/**
 * DTO pour la réponse batch d'utilisateurs
 */
export interface GetUsersBatchResponseDto {
  users: UserResponseDto[]
}
